/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 10/01/2014
 * Time: 08:10
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
    factory('LoyaltyCardCategoryView',["$log","LoyaltyCardView","LoyaltyCardCategoryData","LoyaltyCardData","LoyaltyCardCategory","LoyaltyCardCategorySrv","LoyaltyCardSrv","StyleColor","ItemCategoryView",
        function ($log,LoyaltyCardView,LoyaltyCardCategoryData,LoyaltyCardData,LoyaltyCardCategory,LoyaltyCardCategorySrv,LoyaltyCardSrv,StyleColor,ItemCategoryView)
        {

        var  LoyaltyCardCategoryView = function (category,catIndex,parentCategoryView,domainView)
        {
            ItemCategoryView.call(this);

            this.catIndex = catIndex;
            this.domainView = domainView;
            this.label = "";
            this.description = "";
            this.loyaltyCardsView = [];
            this.categoriesView = [];
            this.image = null;
            this.companyImage = null;
            this.imageDisplayed = null; //eguals to companyImage if defined else GlobalImage
            this.styleView = {};  //styleView is an object and category.style is a string
            this.colorPicker = ""; //value liked by the colorpicker
            this.specificImage = null;
            this.isVisibleOnWebSite = true;
            this.parentCategoryView = null;
            this.selectedLoyaltyCardView=null;
            this.displayType ="array";// only on view loaded by web site theme    //thumbnail //array //selector-array //selector-image
            this.displayLoyaltyCardImages = true;// only on view if children images are different than son

            if (parentCategoryView!==undefined && parentCategoryView!=null)
                this.parentCategoryView=  parentCategoryView;

            this.styleView = this.getStyleFrom(category);
            if (this.styleView)
                this.colorPicker = this.styleView.background;

            if (category!==undefined && category!=null)
            {
                var loyaltyCardView;
                this.loadDataFrom(category);
                for (var i=0;i< category.categories.length;i++)
                    this.categoriesView.push(new LoyaltyCardCategoryView(category.categories[i],LoyaltyCardCategoryData.getIndexOf(category.categories[i]),this,domainView));
                for (var j=0;j< category.loyaltyCards.length;j++)
                {
                    loyaltyCardView  = new LoyaltyCardView(category.loyaltyCards[j],LoyaltyCardData.getIndexOf(category.loyaltyCards[j]),this,domainView);
                    this.loyaltyCardsView.push(loyaltyCardView);
                    if (this.domainView && this.domainView.addLoyaltyCardViewIndex!==undefined)
                        this.domainView.addLoyaltyCardViewIndex(loyaltyCardView);
                }
            }
        }

        LoyaltyCardCategoryView.prototype = Object.create(ItemCategoryView.prototype);//inherit functions from ItemCategoryView

        LoyaltyCardCategoryView.prototype.setImage = function(image)
        {
            for (var j=0;j< this.loyaltyCardsView.length;j++)
                if (this.loyaltyCardsView[j].image==null && !this.loyaltyCardsView[j].specificImage)//if same than previous change
                    this.loyaltyCardsView[j].setImage(image)
            this.image = image;
            this.companyImage = null;
            this.imageDisplayed = this.image;

        }

        LoyaltyCardCategoryView.prototype.setCompanyImage = function(companyImage)
        {
            for (var j=0;j< this.loyaltyCardsView.length;j++)
                if (this.loyaltyCardsView[j].companyImage==null && !this.loyaltyCardsView[j].specificImage)//if same than previous change
                    this.loyaltyCardsView[j].setImage(companyImage)
            this.image = null;
            this.companyImage = companyImage;
            this.imageDisplayed = this.companyImage;
        }

        LoyaltyCardCategoryView.prototype.getCategoryView  = function(category)
        {
            var categoryView =null;
            if (this.getModel()===category)
                return this;
            for (var i=0;i< this.categoriesView.length && categoryView==null;i++)
                categoryView = this.categoriesView[i].getCategoryView(category);
            return categoryView;
        }

        LoyaltyCardCategoryView.prototype.getLoyaltyCardView  = function(loyaltyCard)
        {
            var loyaltyCardView = null;
            for (var j = 0; j < this.loyaltyCardsView.length; j++)
                if (this.loyaltyCardsView[j].getModel() === loyaltyCard)
                    return this.loyaltyCardsView[j];
            for (var z=0;z< this.categoriesView.length && !loyaltyCardView;z++)
                loyaltyCardView = this.categoriesView[z].getLoyaltyCardView(loyaltyCard);

            return loyaltyCardView;
        }
            LoyaltyCardCategoryView.prototype.getLoyaltyCardViewById  = function(id)
            {
                var loyaltyCard;
                for (var j = 0; j < this.loyaltyCardsView.length; j++)
                {
                    loyaltyCard = this.loyaltyCardsView[j].getModel();
                    if (loyaltyCard && loyaltyCard.id == id)
                        return this.loyaltyCardsView[j];
                }
                var loyaltyCardView = null;
                for (var z=0;z< this.categoriesView.length&&!loyaltyCardView ;z++)
                    loyaltyCardView = this.categoriesView[z].getLoyaltyCardViewById(id);
                return loyaltyCardView;
            };
            LoyaltyCardCategoryView.prototype.getCategoryViewById  = function(id)
            {
                var categoryView = null;
                var category = this.getModel();
                if (category && category.id ==id)
                    return this;
                for (var z=0;z< this.categoriesView.length && !categoryView;z++)
                    categoryView = this.categoriesView[z].getCategoryViewById(id);
                return categoryView;
            };
        LoyaltyCardCategoryView.prototype.getAllLoyaltyCardsView  = function(loyaltyCard)
        {
            var lLoyaltyCardsView = this.loyaltyCardsView.slice(0);

            var array;
            for (var z=0;z< this.categoriesView.length;z++)
            {
                array = this.categoriesView[z].getAllLoyaltyCardsView();
                if (array)
                    for(var j = 0; j < array.length; j++)
                        lLoyaltyCardsView.push(array[j])
            }


            return lLoyaltyCardsView;
        }


        LoyaltyCardCategoryView.prototype.getLoyaltyCardViewByCode  = function(code)
        {
            var loyaltyCardView = null;
            for (var j = 0; j < this.loyaltyCardsView.length; j++)
                if (this.loyaltyCardsView[j].code == code)
                    return this.loyaltyCardsView[j];
            for (var z=0;z< this.categoriesView.length && !loyaltyCardView;z++)
                loyaltyCardView = this.categoriesView[z].getLoyaltyCardViewByCode(code);
            return loyaltyCardView;
        }


        LoyaltyCardCategoryView.prototype.copyDataTo = function(category)
        {
            //Assume here than the object in parameter contains only id (must load them)
            category.label = this.label;
            category.description = this.description;
            if (this.parentCategoryView && this.styleView===this.parentCategoryView.styleView)// if is specific set it
                category.style = null;
            else
                category.style = angular.toJson(this.styleView);
            category.image = this.image;
            category.companyImage = this.companyImage;
            category.specificImage = this.specificImage;
            category.isVisibleOnWebSite = this.isVisibleOnWebSite;

        }
        LoyaltyCardCategoryView.prototype.loadDataFrom = function(category)
        {
            this.label = category.label;
            this.description = category.description;
            this.image = category.image;
            this.companyImage = category.companyImage;
            this.specificImage = category.specificImage;
            if (this.companyImage)
                this.imageDisplayed = this.companyImage;
            else
                this.imageDisplayed = this.image;
            this.isVisibleOnWebSite = category.isVisibleOnWebSite;
        }
        LoyaltyCardCategoryView.prototype.onStyleViewChange = function()
        {
            var fontColor = StyleColor.getContrastYIQ(this.colorPicker);
            if (!this.styleView || this.styleView.background !=this.colorPicker)
            {
                if (!this.styleView ||//if undefined
                    (this.parentCategoryView && this.parentCategoryView.styleView===this.styleView ))// if same than parent : break inheritance
                    this.styleView = {};
                this.styleView.background  = this.colorPicker;
                this.styleView.color  = fontColor;
                this.updateStyleView();
            }
        }
        LoyaltyCardCategoryView.prototype.updateStyleView = function(styleView)
        {
            for (var j=0;j< this.categoriesView.length;j++)
                if (this.categoriesView[j].styleView==null)//if same than previous change
                    this.categoriesView[j].updateStyleView(styleView)
        }
        LoyaltyCardCategoryView.prototype.getStyleFrom = function(category)
        {
            var styleView = null;
            if (category)
                if (category.style && category.style.indexOf('{')!=0) //Previous type before 1.5 was not contains a jsonSTring
                    styleView = null;
                else
                    try {
                        styleView = angular.fromJson(category.style);
                    }
                    catch (ex) {
                        console.log("Error loading style")
                    }
            if (!styleView)
                if (this.parentCategoryView!=null)
                    styleView = this.parentCategoryView.styleView;
            return styleView;
        }
        LoyaltyCardCategoryView.prototype.isChanged = function()
        {
            var category = this.getModel();
            if (category)
            {
                /*var image = category.image;
                if ((image==null||image=="") &&this.parentCategoryView)
                    image = this.parentCategoryView.image;*/
                var styleView  = this.getStyleFrom(category);
                var styleChanged = (this.styleView && !styleView) ||
                    !this.styleView && styleView ||
                    (this.styleView && styleView &&
                     this.styleView.background != styleView.background);
                return (
                    this.label != category.label ||
                    this.description != category.description ||
                    styleChanged ||
                    this.image != category.image ||
                    this.companyImage !=  category.companyImage
                );

            }
            else
                return true;

        }
        LoyaltyCardCategoryView.prototype.getModel = function()
        {
            if (this.catIndex!=-1)
                return LoyaltyCardCategoryData.getByIndex(this.catIndex);
            return null;
        }
        LoyaltyCardCategoryView.prototype.restoreModel = function()
        {   //undeleted
            var category = this.getModel();
            if (category)
            {
                if (category.parentCategory)
                    category.parentCategory.addCategory(category);
                LoyaltyCardCategorySrv.restore(category);
            }

        }
        LoyaltyCardCategoryView.prototype.updateModel = function()
        {
            var category = this.getModel();
            if (category==null)
            {
                category = new LoyaltyCardCategory();
                this.catIndex = LoyaltyCardCategoryData.getIndexOf(category);
            }

            this.copyDataTo(category);
            if (this.parentCategoryView) {
                var parentCategory = this.parentCategoryView.getModel();
                if (parentCategory && parentCategory !== category.parentCategory) // change of category
                {
                    if (category.parentCategory)
                        category.parentCategory.removeCategory(category);
                    parentCategory.addCategory(category);
                }
            }
            //modify order of categories
            category.categories = [];
            for (var i=0;i<this.categoriesView.length;i++)
                category.addCategory(this.categoriesView[i].getModel());
            category.loyaltyCards = [];
            for (var i=0;i<this.loyaltyCardsView.length;i++)
                category.addLoyaltyCard(this.loyaltyCardsView[i].getModel());

            LoyaltyCardCategorySrv.save(category, null, this.checkForRootSaveError);
        };

        LoyaltyCardCategoryView.prototype.reloadModel = function()
        {
            var category = this.getModel();
            if (category == null)
            {
                this.parentCategoryView.removeCategoryView(this);
            }
            else
            {
                var styleView = this.getStyleFrom(category);
                if (this.styleView && styleView)
                {
                    this.styleView.background = styleView.background;
                    this.styleView.color = styleView.color;
                }
                else
                    this.styleView = styleView;
                if (this.styleView)
                    this.colorPicker = this.styleView.background;

                this.loadDataFrom(category)
            }
        }
        LoyaltyCardCategoryView.prototype.removeModel = function()
        {
            var category = this.getModel();
            if (category!=null)
            {
                if (category.parentCategory)
                    category.parentCategory.removeCategory(category);
                LoyaltyCardCategorySrv.remove(category);
            }
        }


        LoyaltyCardCategoryView.prototype.removeSelections = function()
        {
            //if one loyaltyCard is known by humanResource : category is known
            for (var i=0;i< this.categoriesView.length;i++)
                this.categoriesView[i].removeSelections();
            for (var j=0;j< this.loyaltyCardsView.length;j++)
                this.loyaltyCardsView[j].isSelected=false;
        }

        LoyaltyCardCategoryView.prototype.addCategoryView = function(categoryView)
        {
            var index = this.categoriesView.indexOf(categoryView);
            if (index==-1)
            {
                this.categoriesView.push(categoryView);
                categoryView.parentCategoryView = this;
            }
        }
        
        LoyaltyCardCategoryView.prototype.removeCategoryView = function(categoryView)
        {
            var index = this.categoriesView.indexOf(categoryView);
            if (index!=-1)
                this.categoriesView.splice(index,1);


        }
        LoyaltyCardCategoryView.prototype.addLoyaltyCardView = function(loyaltyCardView)
        {
            var index = this.loyaltyCardsView.indexOf(loyaltyCardView);
            if (index==-1)
            {
                this.loyaltyCardsView.push(loyaltyCardView);
                loyaltyCardView.parentCategoryView = this;
            }
        }

        LoyaltyCardCategoryView.prototype.removeLoyaltyCardView = function(loyaltyCardView)
        {
            var index = this.loyaltyCardsView.indexOf(loyaltyCardView);
            if (index!=-1)
            {
                this.loyaltyCardsView.splice(index,1);
            }


        }
        LoyaltyCardCategoryView.prototype.changeCategoryPosition = function(scope,categoryView,indexTarget)
        {
            //Change the category position
            // This : parentCategory
            // categoryView : category to move to indexTarget

            var category = this.getModel();
            var index = this.categoriesView.indexOf(categoryView);
            //Todo check indexTarget!=index
            if (category && indexTarget!=-1 && index!=-1 &&  this.categoriesView && indexTarget<=this.categoriesView.length)
            {
                this.categoriesView.splice(index,1); //remove it
                category.categories.splice(index,1);
                scope.$apply();//TODO CHECK WHY Two APPLYs ARE NEEDED
                if (index<indexTarget)
                    indexTarget--;
                if (indexTarget==this.categoriesView.length)
                {
                    this.categoriesView.push(categoryView);
                    category.categories.push(categoryView.getModel());
                }
                else
                {
                    this.categoriesView.splice(indexTarget,0,categoryView);//insert
                    category.categories.splice(indexTarget,0,categoryView.getModel());
                }
                LoyaltyCardCategorySrv.save(category, null, this.checkForRootSaveError);
            }
            scope.$apply();


        }
        LoyaltyCardCategoryView.prototype.changeLoyaltyCardPosition = function(scope,loyaltyCardView,indexTarget)
        {
            //Change the category position
            // This : parentCategory
            // loyaltyCardView : loyaltyCard to move to indexTarget
            var category = this.getModel();
            var index = this.loyaltyCardsView.indexOf(loyaltyCardView);
            //Todo check indexTarget!=index
            if (category && indexTarget!=-1 && index!=-1 &&  this.loyaltyCardsView && indexTarget<=this.loyaltyCardsView.length)
            {
                this.loyaltyCardsView.splice(index,1); //remove it
                category.loyaltyCards.splice(index,1);
                scope.$apply();//TODO CHECK WHY TO APPLY ARE NEEDED
                if (index<indexTarget)
                    indexTarget--;
                if (indexTarget==this.loyaltyCardsView.length)
                {
                    this.loyaltyCardsView.push(loyaltyCardView);
                    category.loyaltyCards.push(loyaltyCardView.getModel());
                }
                else
                {
                    this.loyaltyCardsView.splice(indexTarget,0,loyaltyCardView);//insert
                    category.loyaltyCards.splice(indexTarget,0,loyaltyCardView.getModel());
                }
                LoyaltyCardCategorySrv.save(category, null, this.checkForRootSaveError);
                scope.$apply();

            }

        };
            LoyaltyCardCategoryView.prototype.changeCategoryPositionView = function(categoryView,indexTarget)
        {
            //Change the category position
            // This : parentCategory
            // categoryView : category to move to indexTarget
            var index = this.categoriesView.indexOf(categoryView);
            if (indexTarget!=-1 && index!=-1 &&  this.categoriesView && indexTarget<=this.categoriesView.length)
            {
                this.categoriesView.splice(index,1); //remove it
                if (indexTarget==this.categoriesView.length)
                    this.categoriesView.push(categoryView);
                else
                    this.categoriesView.splice(indexTarget,0,categoryView);//insert
            }
        };
        LoyaltyCardCategoryView.prototype.changeLoyaltyCardPositionView = function(loyaltyCardView,indexTarget)
        {
            //Change the loyaltyCard position

            var index = this.loyaltyCardsView.indexOf(loyaltyCardView);
            //Todo check indexTarget!=index
            if (indexTarget!=-1 && index!=-1 &&  this.loyaltyCardsView && indexTarget<=this.loyaltyCardsView.length)
            {
                this.loyaltyCardsView.splice(index,1); //remove it
                if (indexTarget==this.loyaltyCardsView.length)
                    this.loyaltyCardsView.push(loyaltyCardView);
                else
                    this.loyaltyCardsView.splice(indexTarget,0,loyaltyCardView);//insert
            }
        }
        LoyaltyCardCategoryView.prototype.moveLoyaltyCard = function(loyaltyCardView)
        {
            if (loyaltyCardView)
            {
                var loyaltyCard = loyaltyCardView.getModel();
                var category = this.getModel();
                if (loyaltyCard && category)
                {
                    if (loyaltyCardView.parentCategoryView)
                    {
                        var index = loyaltyCardView.parentCategoryView.loyaltyCardsView.indexOf(loyaltyCardView);
                        if (index!=-1)
                        {
                            loyaltyCardView.parentCategoryView.loyaltyCardsView.splice(index,1);
                            loyaltyCard.parentCategory.loyaltyCards.splice(index,1);

                        }
                    }
                    this.addLoyaltyCardView(loyaltyCardView);
                    category.addLoyaltyCard(loyaltyCard)
                    LoyaltyCardSrv.save(loyaltyCard);
                }
            }
        }
        LoyaltyCardCategoryView.prototype.moveCategory = function(categoryView)
        {
            if (categoryView)
            {
                var categoryToMove = categoryView.getModel();
                var category = this.getModel();
                if (categoryToMove && category)
                {
                    if (categoryView.parentCategoryView)
                    {
                        var index = categoryView.parentCategoryView.categoriesView.indexOf(categoryView);
                        if (index!=-1)
                        {
                            categoryView.parentCategoryView.categoriesView.splice(index,1);
                            categoryToMove.parentCategory.categories.splice(index,1);
                        }

                    }
                    this.addCategoryView(categoryView)
                    category.addCategory(categoryToMove)
                    LoyaltyCardCategorySrv.save(categoryToMove, null, this.checkForRootSaveError);
                }
            }
        }
        LoyaltyCardCategoryView.prototype.canSave = function()
        {
            return (this.label && this.label!="" )

        }
        LoyaltyCardCategoryView.prototype.initWebDisplay = function()
        {
            for (var i=0;i< this.categoriesView.length;i++)
                this.categoriesView[i].initWebDisplay();

            this.displayLoyaltyCardImages = false;
            for (var j=0;j< this.loyaltyCardsView.length && !this.displayLoyaltyCardImages;j++)
                if (this.loyaltyCardsView[j].imageDisplayed!==this.imageDisplayed)
                    this.displayLoyaltyCardImages = true;
            for (var j=0;j< this.categoriesView.length && !this.displayServiceImages;j++)
                if (this.categoriesView[j].imageDisplayed!==this.imageDisplayed)
                    this.displayLoyaltyCardImages = true;

            if (this.displayLoyaltyCardImages)
                this.displayType="thumbnail";
            else
                this.displayType="array";
        };
        LoyaltyCardCategoryView.prototype.populateDisplayTypeResource = function(array)
        {
            var defaultDType =  this.displayLoyaltyCardImages ? "thumbnail" : "array";
            if (this.displayType!=defaultDType)
            {
                var cat = this.getModel();
                if (cat)
                    array.push({id:cat.id,type:this.displayType});
            }
            for (var i=0;i< this.categoriesView.length;i++)
                this.categoriesView[i].populateDisplayTypeResource(array);
        };

        return LoyaltyCardCategoryView;
}]);



// WEBPACK FOOTER //
// ./js/services/views/LoyaltyCardCategoryView.js